<template>
  <div :class="['snackbar', barStateClass]" @click="emits('click', $event)">
    <CheckCircle class="snackbar__icon" v-if="state === 'success'" />
    <CrossCircle class="snackbar__icon" v-else />
    <span class="snackbar__message">{{ header }}</span>
    <p v-if="text" class="snackbar__description">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CheckCircle from '@/assets/CheckCircle.svg'
import CrossCircle from '@/assets/CrossCircle.svg'
import { SnackbarState } from '@/store/application-store'

interface Props {
  state: SnackbarState
  header: string
  text?: string
}

const props = defineProps<Props>()

const barStateClass = computed(() => 'snackbar' + '--' + props.state )

interface Emits {
  (event: 'click', e: MouseEvent): void
}

const emits = defineEmits<Emits>()
</script>

<style lang="scss">
.snackbar {
  width: 300px;
  height: auto;
  padding: 16px;
  color: $white;
  border: 1px solid $grey-80;
  border-radius: 4px;

  display: flex;
  flex-flow: row;
  align-items: center;
  flex-wrap: wrap;

  &--error {
    border-left: 8px solid $danger-red;
    background-color: $black;
    color: $white;
  }

  &--success {
    border-left: 8px solid $success-green;
    background-color: $black;
    color: $white;
  }

  &__icon {
    margin-right: 16px;
    align-self: flex-start;
  }
  
  &__message {
    font-size: 16px;
    font-family: $font-bold;
    line-height: 19px;
    max-width: 218px;;
  }

  &__description {
    margin-top: 12px;
    font-size: 15px;
    font-family: $font-medium;
    line-height: 21px;
    margin-left: 40px;
  }
}
</style>
